import { HbrCheckbox, HbrInput } from '@harbor/elements-react-standalone';
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../support/store';
import { OpportunityPoV } from '../../../../../types/opportunity-pov-items';

interface CiscoTeamSectionProps {
  pov: OpportunityPoV;
  selectedProduct: any;
  onValidationChange: (isValid: boolean) => void;
  onLoadingChange: (isLoading: boolean) => void;
  onSeManagerApprovedChange: (approved: boolean) => void;
}

const style = {
  control: 'w-80 max-w-full min-h-20',
};

const CiscoTeamSection: React.FC<CiscoTeamSectionProps> = ({
  pov,
  selectedProduct,
  onValidationChange,
  onLoadingChange,
  onSeManagerApprovedChange,
}) => {
  const { name: userName } = useSelector((state: RootState) => state.user.userData);
  const { name: managerName } = useSelector((state: RootState) => state.user.manager);

  const isLoading = !selectedProduct;

  // Report loading state to parent
  useEffect(() => {
    onLoadingChange(isLoading);
  }, [isLoading, onLoadingChange]);

  const {
    control,
    reset,
    getValues,
  } = useForm({
    defaultValues: {
      owner: '',
      seManager: '',
      seManagerApproved: false,
    },
  });

  // Reset form when selectedProduct changes
  useEffect(() => {
    if (!isLoading && selectedProduct) {
      reset({
        owner: userName ?? '',
        seManager: managerName ?? '',
        seManagerApproved: selectedProduct?.sem_approved ?? false,
      });
    }
  }, [selectedProduct, isLoading, userName, managerName, reset]);

  // Report validation state to parent
  useEffect(() => {
    const isValid = !!(
      getValues('owner') &&
      getValues('seManager') &&
      getValues('seManagerApproved')
    );
    onValidationChange(isValid);
  }, [getValues, onValidationChange, selectedProduct?.sem_approved]);

  return (
    <>
      <div className={style.control}>
        <Controller
          name='owner'
          control={control}
          rules={{ required: true }}
          render={({ field: { ref, ...field } }) => (
            <HbrInput
              {...field}
              disabled
              label='PoV Owner'
              value={field.value ?? ''}
            />
          )}
        />
      </div>

      <div className={style.control}>
        <Controller
          name='seManager'
          control={control}
          rules={{ required: true }}
          render={({ field: { ref, ...field } }) => (
            <HbrInput
              {...field}
              value={field.value}
              label='SE Manager'
              disabled
            />
          )}
        />
      </div>

      <div className={style.control}>
        <Controller
          name='seManagerApproved'
          control={control}
          render={({ field: { ref, ...field } }) => (
            <HbrCheckbox
              name={field.name}
              checked={!!field.value}
              disabled
              onHbr-change={(e) => {
                const checked = !!e.target.checked;
                field.onChange(checked);
                onSeManagerApprovedChange(checked);
              }}
              onBlur={field.onBlur}
              label="SE Manager Approved"
            />
          )}
        />
      </div>
    </>
  );
};

export default CiscoTeamSection;
